import { render } from "./new-client-pj.vue?vue&type=template&id=20afb0fd"
import script from "./new-client-pj.vue?vue&type=script&lang=js"
export * from "./new-client-pj.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__